// extracted by mini-css-extract-plugin
export var anchored = "testimonialBlock-module--anchored--5062e";
export var author = "testimonialBlock-module--author--47ffe";
export var btnFacebook = "testimonialBlock-module--btn-facebook--c952e";
export var btnLinkedin = "testimonialBlock-module--btn-linkedin--150a1";
export var btnWechat = "testimonialBlock-module--btn-wechat--82567";
export var btnXing = "testimonialBlock-module--btn-xing--79680";
export var btnYoutube = "testimonialBlock-module--btn-youtube--2e46c";
export var contentContainer = "testimonialBlock-module--contentContainer--c5320";
export var headline = "testimonialBlock-module--headline--6964f";
export var icon = "testimonialBlock-module--icon--49df0";
export var iconText = "testimonialBlock-module--icon-text--a1e78";
export var imageBlock = "testimonialBlock-module--imageBlock--4052d";
export var imageContainer = "testimonialBlock-module--imageContainer--2a98c";
export var mail = "testimonialBlock-module--mail--a32d4";
export var paginationElement = "testimonialBlock-module--paginationElement--6654e";
export var phone = "testimonialBlock-module--phone--3a33e";
export var printer = "testimonialBlock-module--printer--ff0d8";
export var sliderControls = "testimonialBlock-module--sliderControls--846fb";
export var tagline = "testimonialBlock-module--tagline--285be";
export var testimonialBlockContainer = "testimonialBlock-module--testimonialBlockContainer--41cdf";
export var testimonialBlockContentSection = "testimonialBlock-module--testimonialBlockContentSection--a5e1f";